import { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';

import useBannerContext from '#client/hooks/useBannerContext';

export default function Notifications({ banners = [] }) {
  const { activeGlobalBanner } = useBannerContext();
  /**
   * The banners have been ordered by priority (highest to lowest)
   * The first banner that is not null or undefined will be shown
   * if banner === undefined, it means the banner is still loading, stop checking the next banner
   * if banner === null, it means loading is done, should check the next banner
   */

  const cachedBanner = useRef(null);

  const activeBanner = banners.find((banner) => banner !== null);
  /**
   * Result of .find method is undefined if no banner is found
   * We need to at least one banner is undefined to know that the active banner is still loading
   */
  const isActiveBannerLoading =
    activeBanner === undefined && banners.some((banner) => banner === undefined);

  useEffect(() => {
    if (!isActiveBannerLoading) {
      cachedBanner.current = activeBanner;
    }
  }, [activeBanner, isActiveBannerLoading]);

  if (activeGlobalBanner) {
    return activeGlobalBanner;
  }

  return isActiveBannerLoading ? cachedBanner.current : activeBanner;
}

Notifications.propTypes = {
  banners: PropTypes.arrayOf(PropTypes.node)
};
